<div *ngIf="case" class="header-info">
  <h2>{{ case.customer.name }}</h2>
  <h6>{{ case.customer.address }} {{ case.customer.city }}</h6>
  <h6>{{ case.customer.mobile }} {{ case.customer.fixe }}</h6>

</div>
